export enum AIInterviewTone {
  Friendly,
  Formal,
  Neutral,
  Empathetic,
  Challenging,
  Humorous
}
